/**
 * /sign/external/$token — External trustee signing (route shell).
 *
 * Public landing — no session required (the magic-link token in the URL is
 * the only auth signal). The full sign UI lives in `./$token-screen.tsx`
 * and is lazy-loaded — keeps the resolution body excerpt + OTP UI out of
 * the main bundle, since 99.9% of traffic never lands here.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/sign/external/$token')({
  component: lazyRouteComponent(
    () => import('./$token-screen'),
    'ExternalSignPage',
  ),
});
